import client from "./client";

const getMe = () => client.get("subsidiary/dashboard/me");

export default { getMe };
